/* eslint-disable react/prop-types */
import React from 'react';
import { Text, View, StyleSheet } from '@react-pdf/renderer';
import FONT_STYLES from '../../PDF/FontStyles';
import PDFBoilerplate from '../../PDF/PDFBoilerplate';
import PDFError from '../../PDF/PDFError';
import PDFTable from '../../PDF/Table/PDFTable';
import formatCurrency from '../../../Dashboard/Widgets/utils/formatCurrency';

const styles = StyleSheet.create({
  ...FONT_STYLES,
  totalsHeaderText: {
    fontSize: 11,
  },
  totalBodyText: {
    fontSize: 8,
  },
  totalsContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
    marginTop: 12,
  },
  col: {
    display: 'flex',
    flexDirection: 'column',
    marginLeft: 8,
    gap: 4,
  },
});

function ProfitAndLossByCustomerPDF({ dateFrom, dateTo, pdfData, userData }) {
  if (!pdfData || !userData) return <PDFError />;

  const { tableData, tableSetup, totals } = pdfData;

  const sizeArray = ['40%', '20%', '20%', '20%'];

  return (
    <PDFBoilerplate
      title="Profit and Loss by Customer"
      dateFrom={dateFrom}
      dateTo={dateTo}
      logoBase64={userData.user.company_logo_base64}
      companyName={userData.user.user_company}
    >
      <PDFTable
        sizeArray={sizeArray}
        tableData={tableData}
        tableSetup={tableSetup}
      />
      <View style={styles.totalsContainer} wrap={false}>
        <View style={styles.col}>
          <Text style={styles.totalsHeaderText}>Totals</Text>
          <Text style={styles.totalBodyText}>Sales:</Text>
          <Text style={styles.totalBodyText}>Expenses:</Text>
          <Text style={styles.totalBodyText}>Income:</Text>
        </View>
        <View style={{ ...styles.col, marginLeft: 12 }}>
          <Text style={styles.totalsHeaderText} />
          <Text style={styles.totalBodyText}>$</Text>
          <Text style={styles.totalBodyText}>$</Text>
          <Text style={styles.totalBodyText}>$</Text>
        </View>
        <View style={styles.col}>
          <Text style={styles.totalBodyText}>
            {formatCurrency(totals.totalSales, 2, false)}
          </Text>
          <Text style={styles.totalBodyText}>
            {formatCurrency(totals.totalExpenses, 2, false)}
          </Text>
          <Text style={styles.totalBodyText}>
            <Text style={styles.bold}>
              {formatCurrency(totals.totalNet, 2, false)}
            </Text>
          </Text>
        </View>
      </View>
    </PDFBoilerplate>
  );
}

export default ProfitAndLossByCustomerPDF;
